export default function partitionSubscriptions(mySubscriptions = []) {
  const seenDevices = new Set();
  const activeSubscriptions = [];

  mySubscriptions.forEach((subscription) => {
    if (subscription.status !== 'ACTIVE') {
      return;
    }

    const deviceKey = subscription.device?.serialNumber;
    if (deviceKey) {
      if (seenDevices.has(deviceKey)) {
        return;
      }
      seenDevices.add(deviceKey);
    }

    activeSubscriptions.push(subscription);
  });

  const inactiveSubscriptions = mySubscriptions.filter((subscription) => (
    subscription.status !== 'ACTIVE' && subscription.status !== 'DUPLICATE'
  ));

  return { activeSubscriptions, inactiveSubscriptions };
}
